import type { AppThunk } from 'state';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import handleRequestError from 'managers/handleRequestError';
import { setUpdating, setUpdatingKey } from '../slice';
import { DataServiceFlightDefinitionRules, FlightDefinitionRulesModel } from 'common/dataService';

function editFlightDefinitionRules(requestParameters: FlightDefinitionRulesModel): AppThunk {
  return async function editFlightDefinitionRulesThunk(dispatch, getState) {
    try {
      const { updating } = getState().flightDefinitionRules.definitionRules;

      if (updating === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setUpdatingKey('edit'));
      dispatch(setUpdating(FetchingStatus.InProgress));

      await DataServiceFlightDefinitionRules.putFlightDefinitionRules(requestParameters);

      dispatch(setUpdating(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(handleRequestError(error, 'Error occured on updating flight definition rules!', setUpdating));
    }
  };
}

export default editFlightDefinitionRules;
